import {
    useDisclosure
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import '../../App.css';
import Alerta from '../../components/Alerta/Alerta';
import AlertaConfirmacao from '../../components/AlertaConfirmacao/AlertaConfirmacao';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import Filtros from '../../components/Filtros/Filtros';
import FormikPadrao from '../../components/FormikPadrao/FormikPadrao';
import InputAutoComplete from '../../components/Inputs/InputAutoComplete/InputAutoComplete';
import InputData from '../../components/Inputs/InputData/InputData';
import InputFiltro from '../../components/Inputs/InputFiltro/InputFiltro';
import InputTexto from '../../components/Inputs/InputTexto/InputTexto';
import Pagina from '../../components/Pagina/Pagina';
import Tabela from '../../components/Tabela/Tabela';
import api from '../../services/api';
import {
    getFiltroPadraoTranferenciaBancaria
} from '../../utils/filtros';
import { gridColumn } from '../../utils/gridColumn';
import './TransferenciasBancarias.css';

function ListarTransferenciasBancarias() {
  const navigate = useNavigate();
  const [showFilters, setShowFilters] = useState(false);
  const [transferencias, setTransferencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search] = useSearchParams();
  const [searchBar, setSearchBar] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: false });
  const [alertStatus, setAlertStatus] = useState('success');
  const {
    isOpen: isOpenExcluir,
    onOpen: onOpenExcluir,
    onClose: onCloseExcluir,
  } = useDisclosure({
    defaultIsOpen: false,
  });
  const [alertTitle, setAlertTitle] = useState('');
  const [message, setMessage] = useState('');
  const [selectedItem, setSelectedItem] = useState('');

  async function GetTransferencias(filtros) {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(filtros, null, 2),
    };
    let res = await api.post('/ListTransferenciasBancarias/Get', payload);
    if (res.status === 200) {
      let data = res.data;
      data.Transferencias.forEach(b => {
        b.Selecionado = false;
      });
      setTransferencias(data.Transferencias);
      setLoading(false);
    } else {
      alert('Erro ao buscar dados');
    }
  }

  useEffect(() => {
    setShowFilters(search.get('filter') === 'true');
    GetTransferencias(getFiltroPadraoTranferenciaBancaria());
  }, [search]);

  function handleDelete(item) {
    setSelectedItem(item.Id);
    setAlertTitle('Excluir');
    setMessage('Deseja excluir a transferência?');
    onOpenExcluir();
  }

  let deleteItem = async () => {
    let payload = {
      data: selectedItem,
      database: localStorage.getItem('database'),
    };
    let res = await api.post('/ListTransferenciasBancarias/Delete', payload);
    let data = res.data;
    onCloseExcluir();
    if (data.Success) {
      setAlertStatus('success');
      setAlertTitle(data.MSG);
      onOpen();
    } else {
      setTransferencias(
        transferencias.filter(item => item.Id !== selectedItem)
      );
      setAlertStatus('error');
      setAlertTitle(data.MSG);
      onOpen();
    }
  };

  function handleEdit(item) {
    navigate(`/TransferenciasBancarias/Editar/${item.Id}`);
  }

  function handleClick() {
    navigate('/TransferenciasBancarias/Editar');
  }

  return (
    <>
      <AlertaConfirmacao
        isOpen={isOpenExcluir}
        onClose={onCloseExcluir}
        description={message}
        title={alertTitle}
        onConfirm={() => deleteItem()}
      />
      <Alerta
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        alertStatus={alertStatus}
        title={alertTitle}
      />
      <Pagina loading={loading}>
        <FormikPadrao
          initialValues={getFiltroPadraoTranferenciaBancaria()}
          onSubmit={async values => {
            await GetTransferencias(values);
          }}
        >
          <BarraBotoes
            botoes={[
              {
                children: 'Novo',
                onClick: handleClick,
                variant: 'turquesa',
              },
            ]}
            search={{
              placeholder: 'Procurar por transferências bancárias',
              onChange: e => setSearchBar(e.target.value),
            }}
          />
          <Filtros show={showFilters}>
            <InputFiltro
              titulo="CÓDIGO"
              id="Codigo"
              name="Codigo"
              component={InputTexto}
              gridColumn={gridColumn.gc4}
            />

            <InputFiltro
              titulo="EMPRESA ORIGEM"
              id="EmpresaOrigem"
              name="EmpresaOrigem"
              component={InputAutoComplete}
              autocomplete={true}
              path={'Empresa'}
              database={localStorage.getItem('database')}
              gridColumn={gridColumn.gc4}
            />
            <InputFiltro
              titulo="BANCO ORIGEM"
              id="BancoOrigem"
              name="BancoOrigem"
              component={InputAutoComplete}
              autocomplete={true}
              path={'Bancos'}
              database={localStorage.getItem('database')}
              gridColumn={gridColumn.gc4}
            />

            <InputFiltro
              titulo="EMPRESA DESTINO"
              id="EmpresaDestino"
              name="EmpresaDestino"
              component={InputAutoComplete}
              autocomplete={true}
              path={'Bancos'}
              database={localStorage.getItem('database')}
              gridColumn={gridColumn.gc4}
            />
            <InputFiltro
              titulo="BANCO DESTINO"
              id="BancoDestino"
              name="BancoDestino"
              component={InputAutoComplete}
              autocomplete={true}
              path={'Bancos'}
              database={localStorage.getItem('database')}
              gridColumn={gridColumn.gc4}
            />
            <InputFiltro
              titulo="Data de Competência"
              id="Data"
              name="Data"
              component={InputData}
              gridColumn={gridColumn.gc4}
            />
          </Filtros>
          <Tabela
            titulo={'LISTAGEM DE TRANSFERÊNCIAS BANCÁRIAS'}
            setFunction={setTransferencias}
            data={transferencias}
            columns={[
              {
                placeholder: 'CÓDIGO',
                name: 'Codigo',
                type: 'text',
              },
              {
                placeholder: 'DATA',
                name: 'DataCompetencia',
                type: 'date',
              },
              {
                placeholder: 'EMPRESA DE ORIGEM',
                name: 'EmpresaOrigem',
                type: 'text',
              },
              {
                placeholder: 'BANCO DE ORIGEM',
                name: 'BancoOrigem',
                type: 'text',
              },
              {
                placeholder: 'EMPRESA DE DESTINO',
                name: 'EmpresaDestino',
                type: 'text',
              },
              {
                placeholder: 'BANCO DE DESTINO',
                name: 'BancoDestino',
                type: 'text',
              },
              {
                placeholder: 'VALOR',
                name: 'Valor',
                type: 'money',
              },
            ]}
            searchBar={searchBar}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            useCheck={false}
          />
        </FormikPadrao>
      </Pagina>
    </>
  );
}

export default ListarTransferenciasBancarias;
